<template>
    <div class="currency-switcher__main-content">
        <div v-for="currency in formattedCurrencies" :key="currency.key" class="currency-switcher__row">
            <div
                :key="currency.value"
                class="currency-switcher__option"
                :class="{ 'currency-switcher__option--selected': currency.value === preferredCurrency }"
                @click="handleOptionClick(currency.value)"
            >
                <div>{{ currency.label }}</div>
                <div>
                    <span>{{ currency.value.toUpperCase() }}</span>
                    <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
                    <span v-if="currency.value !== 'chf'"> - {{ currency.symbol }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getSupportedCurrencies } from '~/store/localization';

export default {
    computed: {
        ...mapGetters(['preferredCurrency']),
        formattedCurrencies() {
            return getSupportedCurrencies().map(currencyCode => ({
                value: currencyCode,
                label: this.getCurrencyLabel(currencyCode),
                symbol: this.getCurrencySymbol(currencyCode),
            }));
        },
    },
    methods: {
        handleOptionClick(code) {
            return this.$emit('option-selected', code);
        },
        getCurrencyLabel(currencyCode) {
            const currencyLabels = {
                sek: this.$t('localization.currencies.sek'),
                nok: this.$t('localization.currencies.nok'),
                eur: this.$t('localization.currencies.eur'),
                dkk: this.$t('localization.currencies.dkk'),
                chf: this.$t('localization.currencies.chf'),
            };

            return currencyLabels[currencyCode] || currencyCode.toUpperCase();
        },
        getCurrencySymbol(currencyCode) {
            const currencySymbols = {
                sek: 'kr',
                nok: 'kr',
                eur: '€',
                dkk: 'kr',
                chf: 'fr',
            };

            return currencySymbols[currencyCode] || currencyCode.toUpperCase();
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.currency-switcher {
    &__row {
        display: flex;
        align-items: center;
        min-height: 32px;

        @media (max-width: #{$bp-hamburger-menu-max}) {
            width: 200px;

            &:first-of-type {
                margin-top: 24px;
            }

            &:last-of-type {
                margin-bottom: 24px;
            }
        }

        &:not(:last-child) {
            margin-bottom: 10px;
        }
    }

    &__option {
        display: flex;
        flex-direction: column;
        align-items: start;
        padding: 8px;
        border-radius: 4px;
        width: 100%;
        cursor: pointer;
        @include font-size(16px);

        span {
            @include font-size(14px);
        }

        &:hover {
            background-color: $neutral-97;
        }

        &--selected {
            font-weight: 700;
            background-color: $neutral-95;
        }
    }
}
</style>
